export default ['ur', 'ir']